export const META = 'metaType';
const MetaMapCollection = new WeakMap();
function getMetaMap(obj) {
    let map = MetaMapCollection.get(obj);
    if (!map) {
        map = new Map();
        MetaMapCollection.set(obj, map);
    }
    return map;
}
/* eslint-disable-next-line @typescript-eslint/no-extraneous-class */
export class Enum {
    static metadata() {
        return Object.fromEntries(getMetaMap(this).entries());
    }
    static metas() {
        // return Object.values(this.metadata());
        return [...getMetaMap(this).values()];
    }
    static meta(value) {
        return this.metas().find(item => item.value === value);
    }
    static [Symbol.iterator]() {
        return Object.values(this).values();
    }
}
const defineMeta = (meta) => {
    return function (target, key) {
        const map = getMetaMap(target);
        const data = { ...meta, key, value: target[key] };
        map.set(key, Object.freeze(data));
    };
};
const declareProperty = ((target, key, descriptor) => {
    if (descriptor) {
        // for Babel
        descriptor.enumerable = false;
        return descriptor;
    }
    else {
        // for TypeScript
        Object.defineProperty(target, key, { enumerable: false });
    }
});
const inheritProperties = ((target) => {
    const parentClass = Object.getPrototypeOf(target);
    const extensions = { ...target };
    Object.keys(target).forEach(key => {
        delete target[key];
    });
    Object.assign(target, parentClass, extensions);
    const metas = target.metas();
    getMetaMap(parentClass).forEach((value, key) => {
        const meta = metas.find(item => item.key === key);
        defineMeta({ ...value, ...meta })(target, key);
    });
});
export { declareProperty as declare, inheritProperties as inherit, defineMeta as meta, };
